<template>
    <div class="card p-20 test-card" :style="{ '--module-color': moduleColor }">
        <div class="d-flex-row flex-justify-between m-b-md">
            <div class="d-flex-row flex-align-center flex-wrap badge-group">
                <span class="badge badge--module" :style="{ backgroundColor: moduleColor }" :title="moduleName">
                    {{ truncatedModuleName }}
                </span>
                <span class="badge badge--primary">
                    {{ test.schedule.type_assessment.name }}
                </span>
            </div>
            <slot name="header-right" />
        </div>

        <div class="d-flex-column p-y-md text-left">
            <div class="d-flex-column">
                <small v-for="entry in academicEntries" :key="entry.key" class="academic-entry m-b-xs">
                    <strong>{{ entry.key }}:</strong> {{ entry.value }}
                </small>
            </div>
        </div>

        <div class="card-footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { getModuleColor, parseAcademic } from '@/scripts/utils';

const MAX_MODULE_NAME_LENGTH = 39;

const props = defineProps({
    test: { type: Object, required: true },
    moduleName: { type: String, default: null }
});

const truncatedModuleName = computed(() => {
    if (!props.moduleName) return '';
    if (props.moduleName.length <= MAX_MODULE_NAME_LENGTH) return props.moduleName;
    return props.moduleName.substring(0, MAX_MODULE_NAME_LENGTH) + '...';
});

const moduleColor = computed(() => getModuleColor(props.moduleName));
const academicEntries = computed(() => parseAcademic(props.test.academic));
</script>
